/* eslint-disable @nx/enforce-module-boundaries */
import { Documents, Music, Pictures, Videos, RecordingPlayIcon } from '@mybridge/icons';

export const RootDirIcon = ({ dir, ...props }) => {
  const { name } = dir ?? {};
  switch (name.toLowerCase()) {
    case 'documents':
      return <Documents {...(props ?? {})} />;
    case 'music':
      return <Music {...(props ?? {})} />;
    case 'pictures':
      return <Pictures {...(props ?? {})} />;
    case 'movies':
      return <Videos {...(props ?? {})} />;
    case 'recordings':
      return <RecordingPlayIcon {...(props ?? {})} />;
  }
};
